import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, PageHead, Chip, Empty, Kicker, Bar } from "@/components/kit";
import { inr, fmtDate } from "@/lib/util";

const Metric = ({ label, value, sub }) => (
  <div className="px-4 py-3" style={{ borderTop: "1px solid var(--hairline)" }}>
    <div className="text-[10px] uppercase tracking-wide font-semibold" style={{ color: "var(--ink-mute)" }}>{label}</div>
    <div className="numeral text-xl mt-1">{value}</div>
    {sub && <div className="text-[11px] mt-0.5" style={{ color: "var(--ink-mute)" }}>{sub}</div>}
  </div>
);

export default function History() {
  const [rows, setRows] = useState(null);

  useEffect(() => { api.get("/history").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  if (!rows) return <Empty line="Gathering the record…" />;

  return (
    <div data-testid="history-page">
      <PageHead
        kicker="The record"
        title="History"
        sub="Every forum year, kept side by side. The table continues; nothing is dropped on 1 July."
      />
      {rows.length === 0 ? (
        <Empty line="No years on record yet." testId="history-empty" />
      ) : (
        <div className="grid lg:grid-cols-2 gap-5 stagger">
          {[...rows].reverse().map((y) => (
            <Card key={y.id} className="!p-0 overflow-hidden" data-testid={`history-year-${y.id}`}>
              <div className="px-5 py-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="numeral text-lg">{y.id}</span>
                  <Chip color={y.status === "Active" ? "var(--green)" : undefined}>{y.status}</Chip>
                </div>
                {y.theme && <div className="text-[14px] font-medium mt-2" style={{ color: "var(--ink)" }}>“{y.theme}”</div>}
                <div className="text-[12px] mt-1.5" style={{ color: "var(--ink-mute)" }}>
                  {fmtDate(y.startDate)} — {fmtDate(y.endDate)}
                </div>
                <div className="text-[12px] mt-2.5 flex gap-2 flex-wrap">
                  {y.moderator && <Chip>Moderator · {y.moderator}</Chip>}
                  {y.coModerator && <Chip>Co · {y.coModerator}</Chip>}
                </div>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3">
                <Metric label="Chapters held" value={`${y.chaptersHeld} / ${y.chaptersPlanned}`} />
                <Metric label="Attendance" value={y.attendancePct === null ? "—" : `${y.attendancePct}%`} />
                <Metric label="Avg goal progress" value={`${y.avgGoalProgress}%`} />
                <Metric label="Goals achieved" value={`${y.goalsAchieved} / ${y.goals}`} />
                <Metric label="Commitments kept" value={`${y.commitmentsKept} / ${y.commitments}`} sub={`${y.commitmentsSlipped} slipped`} />
                <Metric label="Fines" value={inr(y.finesTotal)} sub={`${inr(y.finesOutstanding)} outstanding`} />
              </div>
              <div className="px-5 py-4" style={{ borderTop: "1px solid var(--hairline)" }}>
                <Kicker>Goal progress</Kicker>
                <div className="mt-2"><Bar value={y.avgGoalProgress} /></div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
